import TrabajaConNosotros from "../components/forms/TrabajaConNosotros";
import styles from "./Sumatealequipo.module.css";

export default function SumateAlEquipo() {
  return <section className={styles.container}>
    <TrabajaConNosotros></TrabajaConNosotros>
  </section>;
}
